var map = {
	"./AIButton.png": 5705,
	"./Background-Without-Light.png": 143,
	"./Background.png": 4583,
	"./BackgroundForIntroPage.png": 9431,
	"./CoreXSystemLogo.png": 3362,
	"./CoreXText.png": 6433,
	"./CorexasLogoWithoutText.png": 6512,
	"./LeftArrow.png": 5173,
	"./RightArrow.png": 5214,
	"./TwinSeye-Logo-Text.png": 6631,
	"./TwinSeye-Logo.png": 695,
	"./TwinSeye-White.png": 7183,
	"./Twinseye-Background.png": 4414,
	"./UsernamePassBackground.png": 1224,
	"./XSagBeyaz.png": 2767,
	"./XSolBeyaz.png": 4304,
	"./en/BaslaButton.png": 6144,
	"./en/DevamEtButton.png": 4063,
	"./en/GirisButton.png": 6669,
	"./en/InnovationRDButton.png": 8368,
	"./en/KaydetButton.png": 7391,
	"./en/KayitliSirketButton.png": 394,
	"./en/NextQuestion.png": 6020,
	"./en/NextQuestionHover.png": 7484,
	"./en/PreviousQuestion.png": 3872,
	"./en/PreviousQuestionHover.png": 4904,
	"./en/StrategyButton.png": 3228,
	"./en/SustainabilityButton.png": 3844,
	"./en/SystemButton.png": 9552,
	"./en/TechnologyButton.png": 2289,
	"./en/YeniSirketButton.png": 9332,
	"./tr/BaslaButton.png": 8459,
	"./tr/DevamEtButton.png": 3892,
	"./tr/GirisButton.png": 998,
	"./tr/InnovationRDButton.png": 3085,
	"./tr/KaydetButton.png": 5322,
	"./tr/KayitliSirketButton.png": 5929,
	"./tr/NextQuestion.png": 5769,
	"./tr/NextQuestionHover.png": 5107,
	"./tr/PreviousQuestion.png": 7133,
	"./tr/PreviousQuestionHover.png": 1511,
	"./tr/StrategyButton.png": 125,
	"./tr/SustainabilityButton.png": 7261,
	"./tr/SystemButton.png": 7225,
	"./tr/TechnologyButton.png": 8216,
	"./tr/YeniSirketButton.png": 7489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;